import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';
import _ from 'lodash';

import { BusinessAndRole } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import businessesAndRolesSelector from 'selectors/businessesAndRolesSelector';

export default createSelector(
  (state: StoreType) => oc(state.app).activeBusiness(),
  businessesAndRolesSelector,
  (activeBusiness, massagedBusinesses): BusinessAndRole | undefined => {
    return _.find(massagedBusinesses, (business) => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      return business.id === activeBusiness!.id;
    });
  }
);
